import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { value: "Extended Childcare Patterns" }),
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        to: "/nursery-hours/edit"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Create New ", -1))
        ]),
        _: 1
      })
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_table, { "fixed-header": "" }, {
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Pattern Name"),
              _createElementVNode("th", null, "Monthly/Spot"),
              _createElementVNode("th", null, "Created Date"),
              _createElementVNode("th", null, "Default Setting"),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patternList, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.patternTitle), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getCategoryName(item.category)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.createdAt)), 1),
                _createElementVNode("td", null, [
                  (item.isDefault == true)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "success",
                        variant: "text",
                        small: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[3] || (_cache[3] = _createTextVNode(" Default ", -1))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        onClick: ($event: any) => (_ctx.setDefaultPattern(item.patternId)),
                        small: "",
                        color: "grey",
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Set as Default ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    onClick: ($event: any) => (
                    _ctx.clickEditPattern({
                      patternId: item.patternId,
                      category: item.category,
                    })
                  ),
                    color: "primary",
                    variant: "flat",
                    small: ""
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Edit", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}